import React from 'react';
import { tns } from 'tiny-slider/src/tiny-slider';
import { SitecoreImageField } from 'components/sitecore-fields';

class TOCHImageGalleryTiles extends React.Component {
    constructor(props) {
        super(props);

        this.gallery = null;
        this.slides = React.createRef();
    }

    componentDidMount() {
        if (this.props.hasCarousel) {
            this.gallery = tns({
                container: this.slides.current,
                loop: false,
                nav: false,
                items: 1,
                controls: false,
                autoWidth: true
            });
            this.props.getNode(this.gallery);
        }
    }

    componentWillUnmount() {
        if (this.gallery !== null) {
            this.gallery.destroy();
        }
    }

    render() {
        const { tiles, onClick } = this.props;
        return (
            <div className='multimedia-carousel__slides' ref={this.slides}>
                {
                    tiles.map((tile, index) => {
                        return (
                            <div className='multimedia-carousel-card' tabIndex={0} key={index}>
                                <div className='multimedia-carousel-card__bg'>
                                    <SitecoreImageField img={tile.image} className='multimedia-carousel-card__img' />
                                </div>
                                <div className='multimedia-carousel-card__content'>
                                    <div className='multimedia-carousel-card__content--text'>
                                        {
                                            tile.link !== null &&
                                            <div className='multimedia-carousel-card__link multimedia-carousel-card__heading' onClick={() => onClick(tile)}>
                                                {tile.title}
                                            </div>
                                        }
                                        {
                                            tile.link === null &&
                                            <div className='multimedia-carousel-card__heading'>
                                                {tile.title}
                                            </div>
                                        }
                                        <span className='multimedia-carousel-card__subtitle'>{tile.subtitle}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default TOCHImageGalleryTiles;
